export const defaultValues = {
  defaultCulture: 'de-DE',
  dateFormats: [
    { name: 'de-DE', translation: 'dd.MM.yyyy' },
    { name: 'en-US', translation: 'yyyy/MM/dd' }
  ],
  timeFormats: [
    { name: 'de-DE', translation: 'HH:mm:ss' },
    { name: 'en-US', translation: 'HH:mm:ss' }
  ],
  enumGroupIds: {
    assetTypesId: 1,
    transactionTypesId: 2,
    transactionImportFileTypesId: 3,
    priceSourcesId: 4,
    dividendIntervalId: 5,
    messagingChannelId: 8,
    bookingTypeId: 9,
  },
  transactionTypeIds: {
    buyId: 3,
    sellId: 4,
    dividendId: 5
  },
  transactionImportFileTypeIds: {
    ingDibaPdf: 6,
    tradeRepublicPdf: 25,
    scalableCapitalPdf: 26,
    smartbrokerPlusPdf: 27
  },
  keywordTypeIds: {
    keywordId: 13,
    indsutryId: 14
  },
  messagingChannelIds: {
    emailId: 23
  },
  countryIds: {
    germanyId: 1
  },
  bookingCategoryIds: {
    loanProperty: 1,
    loanModernization: 2,
    loanRepayment: 3,
    loanInterest: 4,
    fittedKitchen: 5
  }
};
